/**
 * Display name rules for a participant.
 *
 * The name is free-form but must stay short enough to render inside a canvas
 * label, and an empty name always falls back to a neutral placeholder.
 */

export const DISPLAY_NAME_MAX_LENGTH = 24;
export const FALLBACK_DISPLAY_NAME = "Participant";

/** Trims, collapses whitespace and clamps the length. */
export function normalizeDisplayName(raw: unknown): string {
  if (typeof raw !== "string") return "";
  return raw.replace(/\s+/g, " ").trim().slice(0, DISPLAY_NAME_MAX_LENGTH);
}

/** Name safe to render: never empty. */
export function resolveDisplayName(raw: unknown): string {
  return normalizeDisplayName(raw) || FALLBACK_DISPLAY_NAME;
}

/** True when the edited value would actually change the published name. */
export function isDisplayNameChanged(current: unknown, next: unknown): boolean {
  return normalizeDisplayName(current) !== normalizeDisplayName(next);
}
